<template>
	<section
		v-if="data && (loadingPostsStatus === 'success' || loadingPostsStatus === 'loading') && postItems.length"
		class="module-posts margin-module"
	>
		<div class="container">
			<div
				:class="{ 'related-title': related }"
				class="margin-bottom-sm text-center"
				v-if="data.module_title || data.title"
			>
				<h2 :class="titleClass">{{ data.module_title || data.title || 'Related articles' }}</h2>
			</div>

			<PostsGrid :class="{ 'list-grid': connected }" v-if="postItems && postItems.length" :posts="postItems" />

			<div class="more-button margin-top-lg text-center">
				<Button :theme="btnTheme" :url="eventArchiveLink" icon="arrowRight">All news</Button>
			</div>
		</div>
	</section>
</template>

<script>
import PostsGrid from '@/components/parts/PostsGrid'
import { mapOrder } from '@/helpers'
import { mapActions, mapGetters } from 'vuex'
import Button from '@/components/elements/Button'

export default {
	name: 'posts-module',
	props: ['data', 'related', 'connected'],
	data() {
		return {
			archiveLinkShow: this.data !== null && this.data.archiveLinkShow === false ? false : true,
			postType:
				this.data && (this.data.type || this.data.show_type) ? this.data.type || this.data.show_type : 'post',
			postItems: [],
			loadingPostsStatus: 'loading',
			eventArchiveLink: WPVUE.pages && WPVUE.pages && WPVUE.pages.posts ? WPVUE.pages.posts.link : '/news',
			categories: [],
			maxPosts: 0,
			isLoadingMore: false,
		}
	},

	components: {
		PostsGrid,
		Button,
	},
	mounted() {
		const VM = this
		if (!VM.data) return false
		VM.loadPosts()
	},
	computed: {
		...mapGetters(['currentPageID', 'getOptions', 'pageTheme']),
		btnTheme() {
			return this.pageTheme && this.pageTheme !== 'default' ? this.pageTheme : 'dark'
		},
		titleClass() {
			if (this.related) {
				return 'module-title related'
			} else {
				return 'module-title'
			}
		},
		includePosts() {
			return this.data.selected_posts || 0
		},

		loadOpt() {
			const VM = this
			if (!VM.data) return []
			let limit = VM.data.limit || 3

			if (VM.includePosts && VM.includePosts.length) limit = VM.includePosts.length

			let opt = {
				type: VM.postType || 'post',
				include: VM.includePosts,
				exclude: VM.data.exclude || 0,
				limit,
				category: VM.data.select_category || 0,
			}

			if (VM.data.meta) opt.meta = VM.data.meta
			if (VM.data.post_to_event) {
				opt.post_to_event = VM.data.post_to_event
				opt.limit = 20
			}
			if (VM.data.value) opt.value = VM.data.value

			return opt
		},
		exclude() {
			let exclude = 0
			if (this.currentPageID) {
				exclude = [this.currentPageID]
			}
			if (this.data.exclude) {
				exclude = [...exclude, ...this.data.exclude]
			}
			return exclude
		},
	},

	methods: {
		...mapActions(['getPost']),

		loadPosts(options) {
			if (!options) {
				options = this.loadOpt
			}
			const VM = this

			if (VM.data.meta) options.meta = VM.data.meta
			if (VM.data.value) options.value = VM.data.value

			VM.loadingPostsStatus = 'loading'
			return VM.getPost(options).then((res) => {
				if (res.data && res.data.posts && res.data.posts.length) {
					if (VM.includePosts) {
						VM.postItems.push(...mapOrder(res.data.posts, VM.includePosts, 'id'))
					} else {
						if (VM.isLoadingMore) {
							VM.postItems = [...VM.postItems, ...res.data.posts]
						} else {
							VM.maxPosts = res.data.posts_found
							VM.postItems = [...res.data.posts]
						}
					}
				}
				if (res.data && res.data.posts && !res.data.posts.length) {
					VM.postItems = []
				}
				VM.isLoadingMore = false
				VM.loadingPostsStatus = 'success'
				return VM.loadingPostsStatus
			})
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-posts {
	.heading-mod {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;

		.module-title {
			margin: 0;
		}
		@include mquery($phone) {
			flex-wrap: wrap;
			.module-title {
				min-width: 100%;
				max-width: 100%;
				order: 2;
				margin-right: 0px;
			}
		}
		&.related-title {
			.related {
				flex: 1;
				text-align: center;
				right: -80.25px;
				position: relative;
				@include mquery($tablet) {
					right: 0;
				}
			}
			@include mquery($phone) {
				svg {
					width: 161px * 0.7;
					height: 100px * 0.7;
				}
			}
		}
	}
	.posts-line {
		margin-bottom: -50px;
		@include mquery($tablet) {
			margin-bottom: -30px;
		}
		@include mquery($phone) {
			margin-bottom: -20px;
		}
	}
}
</style>
